/**
 * Route công khai cho khách chọn ảnh — nằm NGOÀI `_app` nên không qua cổng
 * đăng nhập. Token trên đường dẫn là quyền duy nhất.
 *
 * File này chỉ khai báo route, không dựng component nào — cùng khuôn
 * `album.$token.tsx` và `photo-select.tsx`.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PhotoSelectionRoute } from "@/features/album-share/PhotoSelectionRoute";

export const Route = createFileRoute("/chon-anh/$token")({
  component: PhotoSelectionRoute,
});
